import React from "react";
import { InitialPostStateType } from "../../assets/data/initialState";
import { FormikType } from "../../types/types";
import { FileInput } from "../Components";

type Props = FormikType<InitialPostStateType>;

export default function PostImage({ formik }: Props) {
  return (
    <div className="mb-8">
      <p className="font-Switzer font-bold text-2xl tracking-tight mb-1">
        Post Image
      </p>
      <p className="font-Switzer text-base tracking-tight mb-2">
        Add an image to this post. Ensure the image you upload relates to the
        content with this post.
      </p>
      <FileInput
        type="images"
        source={formik.values.image ?? ""}
        onSelect={(file) => formik.setFieldValue("newImage", file)}
        onRemove={() => {
          formik.setFieldValue("image", "");
          formik.setFieldValue("newImage", undefined);
        }}
      />
    </div>
  );
}
